import Yup from 'utils/validation';
import { businessFormInitialValues } from '../utils';
import { validDDDs } from 'utils/basicUtils';

export const restaurantsInitialValues = {
  ...businessFormInitialValues,
};

export const restaurantsValidationSchema = Yup.object().shape({
  id: Yup.number(),
  businessRepresentative: Yup.string()
    .required()
    .test('not-empty', 'Campo não pode conter apenas espaços', value => value?.trim().length > 0),
  businessOwner: Yup.array().of(
    Yup.string()
      .required()
      .test('not-empty', 'Campo não pode conter apenas espaços', value => value?.trim().length > 0)
  ),
  businessType: Yup.string()
    .required()
    .test('not-empty', 'Campo não pode conter apenas espaços', value => value?.trim().length > 0),
  description: Yup.string()
    .required()
    .test('not-empty', 'Campo não pode conter apenas espaços', value => value?.trim().length > 0),
  document: Yup.string().notRequired(),
  experiences: Yup.array().min(1).required(),
  googleMapsLink: Yup.string()
    .required()
    .test('not-empty', 'Campo não pode conter apenas espaços', value => value?.trim().length > 0),
  tradeName: Yup.string()
    .required()
    .test('not-empty', 'Campo não pode conter apenas espaços', value => value?.trim().length > 0),
  tradeEmail: Yup.string().notRequired(),
  title: Yup.string()
    .required()
    .test('not-empty', 'Campo não pode conter apenas espaços', value => value?.trim().length > 0),
  phone: Yup.string().notRequired(),
  site: Yup.string().notRequired(),
  youtubeLink: Yup.string().notRequired(),
  instagramLink: Yup.string().notRequired(),
  facebookLink: Yup.string().notRequired(),
  whatsapp: Yup.string(),
  image: Yup.array().min(1).required(),
  address: Yup.object().shape({
    id: Yup.number(),
    city: Yup.string()
      .required()
      .test('not-empty', 'Campo não pode conter apenas espaços', value => value?.trim().length > 0),
    neighborhood: Yup.string()
      .matches(/^(?!^\d+$)[\d\D]*$/, 'O bairro não pode conter somente números')
      .required()
      .test('not-empty', 'Campo não pode conter apenas espaços', value => value?.trim().length > 0),
    number: Yup.string()
      .matches(/^\d*$/, 'O campo número deve conter apenas números')
      .required()
      .test('not-empty', 'Campo não pode conter apenas espaços', value => value?.trim().length > 0),
    state: Yup.string()
      .required()
      .test('not-empty', 'Campo não pode conter apenas espaços', value => value?.trim().length > 0),
    street: Yup.string()
      .matches(/^(?!\d+$).*/, 'O campo endereço não pode ser apenas números')
      .required()
      .test('not-empty', 'Campo não pode conter apenas espaços', value => value?.trim().length > 0),
    zipCode: Yup.string().notRequired(),
  }),
  images: Yup.array().min(1).required(),
});
